module.exports = __webpack_public_path__ + "static/media/javascript-lab2-full-view.cea6ecf0.JPG";